module.exports = __webpack_public_path__ + "static/media/background.a286b08f.png";